import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const EditInboundDeliveryMutation = graphql(/* GraphQL */ `
  mutation editInboundDelivery(
    $editInboundDeliveryInput: EditInboundDeliveryInput!
  ) {
    editInboundDelivery(input: $editInboundDeliveryInput) {
      inboundDeliveryDetail {
        id
      }
    }
  }
`);
